import React from "react";
import PropTypes from "prop-types";
import CSSModules from "react-css-modules";
import styles from "./auth-layout.scss";
import logo from "./files/sunbit-logo-with-blue-text.svg";
import { Grid, Row, Col } from "react-flexbox-grid/lib";



@CSSModules(styles)
class AuthLayout extends React.Component {

  static propTypes = {
    children: PropTypes.node
  };

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div styleName="auth-layout">
        <Grid>
          <Row center="xs">
            <Col xs={12} sm={10} md={8} lg={7} styleName="content">
              <div styleName={'contentInner'}>
                <img src={logo} alt="" />
                {this.props.children}
              </div>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12} sm={10} md={8} lg={7}>
              <div styleName="rights">© {new Date().getFullYear()} Sunbit</div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default AuthLayout;



// WEBPACK FOOTER //
// ./src/components/layout/auth/AuthLayout.js